import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "./Reveal";
import { useLeadModal } from "@/context/LeadModalContext";

export const FinalCTA = () => {
  const { openModal } = useLeadModal();
  return (
    <section id="accesso" className="bg-ink text-ivory py-28 sm:py-44" data-testid="final-cta">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-goldtan mb-10">EARLY ACCESS</p>
        </Reveal>
        <h2 className="font-display font-light text-5xl sm:text-7xl lg:text-[6rem] leading-[1.0] tracking-tight">
          <MaskedLines lines={["Il tuo brand", "può iniziare da qui."]} className="block" />
        </h2>

        <Reveal delay={0.1}>
          <p className="mt-10 font-sans-ui text-base sm:text-lg text-ivory/70 leading-relaxed max-w-2xl mx-auto">
            Stiamo aprendo l'accesso a My Brand Online a un numero limitato di nuovi clienti. Se hai già un ecommerce,
            un negozio, una community oppure vuoi creare il tuo brand fashion, richiedi l'accesso e scopri come iniziare.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <button
            data-testid="final-cta-button"
            onClick={openModal}
            className="group mt-12 inline-flex items-center gap-4 bg-ivory text-ink px-12 py-5 text-xs tracking-mega font-semibold hover:bg-goldtan hover:text-ink transition-colors duration-300"
          >
            RICHIEDI ACCESSO ANTICIPATO
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
          </button>
          <p className="mt-6 font-sans-ui text-xs text-ivory/45 tracking-wide">
            Nessun impegno. Ti mostreremo come funziona My Brand Online e come può adattarsi alla tua attività.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
